module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-deal-xs-90badca62ae5461558909ff06cd6d506.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-deal-xs.jpg
// module id = 353
// module chunks = 2